// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"4326a735","317":"47b0bb40"}[chunkId] + ".chunk.js";
};